<template>
  <div class="added-file">
    <label class="added-file__button" :class="{'added-file__button_hidden': !stateParentComponent}" :for="'fileForm' + idLabel">
      <IconBase icon-name="add-file" class="added-file__icon-add" viewBox="0 0 20 20">
        <IconAddFile/>
      </IconBase>
      <span>
        Прикрепить файл
      </span>
      <input :id="'fileForm' + idLabel" type="file" accept="image/*,video/*" @change="addFiles($event)">
    </label>
    <div class="added-file__container-file"
         :class="{'added-file__container-file_not-files': checkLength, 'added-file__container-file_warn': validationObject.error}">
      <div v-for="(file, index) in files" class="added-file__file" :class="{'added-file__file_preview': !stateParentComponent}"
           @click="clickFile($event, stateParentComponent)" :data-index-file="index">
        <template v-if="checkedType(file)">
          <img class="icon-delete" src="/local/templates/adaptive_cmtshop/reviews/src/assets/images/delete.png">
          <img class="image file" alt="файл" :src="file.src" :data-file-uuid="file.uuid">
        </template>
        <template v-else>
          <img class="icon-delete" src="/local/templates/adaptive_cmtshop/reviews/src/assets/images/delete.png">
          <img class="icon-play" src="/local/templates/adaptive_cmtshop/reviews/src/assets/images/play.png">
          <video class="video file" type='video/mp4' :data-file-uuid="file.uuid">
            <source class="file" :src="file.src">
          </video>
        </template>
      </div>
    </div>
    <div v-for="item in validationObject.warningArr" class="reviews__form-warning"
         :class="[{'reviews__form-warning_active': item}, 'reviews__form-warning_active-file']">
      <div>
        {{ item }}
      </div>
    </div>
  </div>
</template>

<script>
import IconAddFile from "@/components/icon/icons/IconAddFile";
import IconBase from "@/components/icon/IconBase";
import eventBus from "@/js/eventBus";

export default {
  name: "AddedFile",
  components: {
    IconBase,
    IconAddFile
  },
  props: {
    review: Object,
    stateParentComponent: Boolean,
  },
  data() {
    return {
      idLabel: '',
      files: [],
      filesSubmit: [],
      indexFile: '',
      validationObject: {
        error: false,
        warningArr: [],
      }
    }
  },
  methods: {
    addFiles(e) {
      this.validationFiles(e);
      if (!this.validationObject.error) {
        const result = new FileReader();
        result.readAsDataURL(e.target.files[0]);
        result.onload = () => {
          this.files.push({
            uuid: e.target.files[0].name,
            type: e.target.files[0].type,
            src: result.result
          });
        };
        this.filesSubmit.push(e.target.files[0]);
        this.$emit('addFiles', this.filesSubmit);
      }
    },
    checkedType(file) {
      if (file.type.split('/')[0] === 'image') {
        return true;
      }
      return false;
    },
    clickFile(e, stateParentComponent) {
      if(stateParentComponent) {
        const fileDOM = e.currentTarget.querySelector('.file');
        const fileUuid = fileDOM.getAttribute('data-file-uuid');
        this.files.splice(this.files.indexOf(this.files.find(item => item.uuid === fileUuid)), 1);
        this.filesSubmit.splice(this.filesSubmit.indexOf(this.filesSubmit.find(item => item.name === fileUuid)), 1);
        this.review ? this.$emit('deleteFile', fileUuid) : '';
      } else {
        const indexFile = Number(e.currentTarget.dataset.indexFile);
        eventBus.$emit('custom-event', this.files, indexFile);
      }
    },
    validationFiles(e) {
      this.validationMaxFile();
      this.validationFileSize(e);
      if (this.validationObject.warningArr.length >= 1) {
        this.validationObject.error = true
      } else {
        this.validationObject.error = false;
      }
      setTimeout(() => {
        this.validationObject.warningArr = [];
        this.validationObject.error = false;
      }, 2000)
    },
    validationMaxFile() {
      const warnMessage = 'Максимальное количество файлов 10'
      if (this.files.length >= 10) {

        if (!this.validationObject.warningArr.includes(warnMessage)) {
          this.validationObject.warningArr.push(warnMessage)
        }
      }
    },
    validationFileSize(e) {
      const warnMessage = 'Размер файла не должен превышать 10мб'
      console.log(e.target.files[0].size)
      if (e.target.files[0].size > 10485760) {

        if (!this.validationObject.warningArr.includes(warnMessage)) {
          this.validationObject.warningArr.push(warnMessage)
        }
      }
    }
  },
  computed: {
    checkLength() {
      if(this.review) {
        return this.review.files.length < 1
      } else {
        return this.files.length < 1
      }
    }
  },
  mounted() {
    if (this.review) {
      this.review.files.forEach(item => this.files.push({
        src: item.src,
        type: item.type,
        uuid: item.uuid
      }));
    }

    this.idLabel = Math.random();
  },
  updated() {
    this.deleteFilesQuestion = [];
  },
  watch: {
    review: function() {
      this.files = [];
      this.review.files.forEach(item => this.files.push({
        src: item.src,
        type: item.type,
        uuid: item.uuid
      }));
    }
  }
}
</script>

<style scoped>

</style>